import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthProvider';
import DevAuthProvider from './contexts/DevAuthProvider';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import SSOCallback from './pages/SSOCallback';
import Dashboard from './pages/Dashboard';
import Following from './pages/Following';
import Suppliers from './pages/Suppliers';
import Invoices from './pages/Invoices';
import ExpenseNotes from './pages/ExpenseNotes';
import Retrocommissions from './pages/Retrocommissions';
import Refunds from './pages/Refunds';
import Proformas from './pages/Proformas';
import Encodage from './pages/Encodage';
import PayPal from './pages/PayPal';
import History from './pages/History';
import Notifications from './pages/Notifications';
import BoarLab from './pages/BoarLab';
import config from './config';

// The pétanque game (three.js, physics, post-processing) loads only when opened.
const PetanqueGame = lazy(() => import('./pages/petanque/PetanqueGame'));

const Provider = config.devAuth ? DevAuthProvider : AuthProvider;
const priv = (el) => <PrivateRoute>{el}</PrivateRoute>;
// Pages restricted per-employee in the HR hub · the key matches the Virgy
// module slug minus its 'sangly-' prefix.
const privModule = (el, module, label) => (
  <PrivateRoute module={module} moduleLabel={label}>{el}</PrivateRoute>
);

function App() {
  return (
    <Provider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/sso-callback" element={<SSOCallback />} />
          <Route path="/dashboard" element={priv(<Dashboard />)} />
          <Route path="/suppliers" element={priv(<Suppliers key="lamptwist" unit="lamptwist" />)} />
          <Route path="/suppliers/:id" element={priv(<Suppliers key="lamptwist" unit="lamptwist" />)} />
          <Route path="/invoices" element={priv(<Invoices key="lamptwist" unit="lamptwist" />)} />
          <Route path="/invoices/:id" element={priv(<Invoices key="lamptwist" unit="lamptwist" />)} />
          {/* Calum Brussels: same pages, scoped to the Calum bills. The key forces a
              fresh page state when switching blocks (filters / search do not carry over). */}
          <Route path="/calum/suppliers" element={priv(<Suppliers key="calum" unit="calum" />)} />
          <Route path="/calum/suppliers/:id" element={priv(<Suppliers key="calum" unit="calum" />)} />
          <Route path="/calum/invoices" element={priv(<Invoices key="calum" unit="calum" />)} />
          <Route path="/calum/invoices/:id" element={priv(<Invoices key="calum" unit="calum" />)} />
          <Route path="/expense-notes" element={priv(<ExpenseNotes />)} />
          <Route path="/expense-notes/:id" element={priv(<ExpenseNotes />)} />
          <Route path="/retrocommissions" element={priv(<Retrocommissions />)} />
          <Route path="/retrocommissions/:id" element={priv(<Retrocommissions />)} />
          <Route path="/refunds" element={priv(<Refunds />)} />
          <Route path="/proformas" element={priv(<Proformas />)} />
          <Route path="/proformas/:id" element={priv(<Proformas />)} />
          <Route path="/encodage" element={privModule(<Encodage />, 'encodage', 'Encodage')} />
          <Route path="/paypal" element={priv(<PayPal />)} />
          <Route path="/following" element={priv(<Following />)} />
          <Route path="/following/:id" element={priv(<Following />)} />
          <Route path="/history" element={priv(<History />)} />
          <Route path="/notifications" element={priv(<Notifications />)} />
          <Route path="/petanque" element={priv(<Suspense fallback={null}><PetanqueGame /></Suspense>)} />
          {/* hidden, unlisted animation playground - no auth needed */}
          <Route path="/lab" element={<BoarLab />} />
          <Route path="/" element={<Navigate to="/suppliers" replace />} />
          <Route path="*" element={<Navigate to="/suppliers" replace />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
